<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{ menuName }}->{{title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="维度/类别设置" name="first">
                <child1></child1>
            </el-tab-pane>
    
            <el-tab-pane label="模板管理" name="second">
                <child2></child2>    
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import setDimension from './setDimension.vue'
    import setTemplate from './setTemplate.vue'

    export default {
        name:"setClockinMain",
        components:{
            child1: setDimension,
            child2: setTemplate
        },
        data() {
            return {
                //默认第一个选项卡
                activeName: "first",
                title:"维度/类别设置",
                menuName: "",
            }
        },
        created: function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key")
        },
        methods:{
            handleClick(tab) {
                if(tab.name == "first") {
                    this.title="维度/类别设置";
                } else if(tab.name == "second") {
                    this.title="模板管理";
                }
            }
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/task/setClockinMain.vue